import React from "react";
import CommonLayout from "../CommonLayout";
import "./index.css";

const PrivacyAndPolicy: React.FC = () => {
  return (
    <CommonLayout
      title="Privacy & Policy"
      showBackButton={true}
    >
      <div className="privacyPolicyPage">
        <iframe
          className="privacyPolicyIframe"
          src="https://www.ink-aa.com/privacy-policy.html"
          title="PrivacyAndPolicy"
          frameBorder="0"
        />
      </div>
    </CommonLayout>
  );
};

export default PrivacyAndPolicy;